import { RadioButtonList } from '@interstate/components/RadioButtonList';
import { usePaymentFrequencyField } from '@makemydeal/dr-dash-components';

import { ScenarioRow } from '../../ScenarioRow';

const SINGLE_LINE_OPTIONS_SX = {
    '.MuiFormGroup-root': {
        flexWrap: 'nowrap',
        justifyContent: 'flex-end',
        gap: '0.75rem',
        padding: 0
    },
    '.MuiFormGroup-root .MuiFormControlLabel-root.MuiFormControlLabel-root': {
        margin: 0,
        whiteSpace: 'nowrap'
    }
};

export const PaymentFrequencyRow = () => {
    const { label, radioProps } = usePaymentFrequencyField();

    return (
        <ScenarioRow rowKey="paymentFrequency" label={label}>
            <RadioButtonList
                {...radioProps}
                sx={SINGLE_LINE_OPTIONS_SX}
                label={label}
                displayLabel={false}
                spacing="sm"
                labelSize="sm"
                inline={true}
            />
        </ScenarioRow>
    );
};
